<template>
	<div class="app-container">
		<!-- 搜索过滤 -->
		<el-card class="filter-card">
			<el-form :inline="true" :model="filterForm" class="filter-form">
				<el-form-item>
					<el-button type="primary" @click="handleAdd">
						<el-icon>
							<Plus />
						</el-icon> 新建流程
					</el-button>
				</el-form-item>
				<el-form-item>
					<el-divider direction="vertical"></el-divider>
				</el-form-item>
				<el-form-item label="流程名称">
					<el-input v-model="filterForm.name" placeholder="请输入流程名称" clearable @keyup.enter="handleSearch" />
				</el-form-item>
				<!-- <el-form-item label="流程状态">
          <el-select v-model="filterForm.status" placeholder="请选择状态" clearable>
            <el-option label="启用" value="active" />
            <el-option label="停用" value="inactive" />
          </el-select>
        </el-form-item> -->
				<el-form-item>
					<el-button type="primary" @click="handleSearch">
						<el-icon>
							<Search />
						</el-icon> 搜索
					</el-button>
					<el-button @click="resetForm">
						<el-icon>
							<Refresh />
						</el-icon> 重置
					</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<!-- 流程列表 -->
		<el-card class="table-card">
			<el-table :data="processList" style="width: 100%" height="calc(100vh - 320px)" v-loading="loading" stripe>
				<el-table-column type="index" label="序号" width="60" />
				<el-table-column prop="name" label="流程名称" />
				<el-table-column prop="description" label="流程描述" show-overflow-tooltip />
				<el-table-column label="审批人" width="300">
					<template #default="scope">
						<div class="approver-list">
							<el-tag v-for="(step, index) in scope.row.tbTemUsers" :key="index" :type="getStepTag(index)"
								size="small" class="step-tag">
								{{ index + 1 }}. {{ step.username }}
							</el-tag>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="抄送人" width="300">
					<template #default="scope">
						<div class="approver-list">
							<el-tag v-for="(step, index) in scope.row.ccUsers1" :key="index" :type="getStepTag(index)"
								size="small" class="step-tag">
								{{ index + 1 }}. {{ step.username }}
							</el-tag>

						</div>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="status" label="状态" width="100">
          <template #default="scope">
            <el-tag :type="scope.row.status === 'active' ? 'success' : 'info'">
              {{ scope.row.status === 'active' ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column> -->
				<el-table-column prop="createTime" label="创建时间" width="180">
					<template #default="scope">
						{{ formatDate(scope.row.createTime) }}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="200" fixed="right">
					<template #default="scope">
						<el-button size="small" type="warning" @click="handleView(scope.row)">详情</el-button>
						<el-button size="small" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
						<!-- <el-button 
              size="mini" 
              :type="scope.row.status === 'active' ? 'warning' : 'success'"
              @click="handleToggleStatus(scope.row)">
              {{ scope.row.status === 'active' ? '停用' : '启用' }}
            </el-button> -->
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination-container">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</el-card>

		<!-- 新建/编辑流程对话框 -->
		<el-dialog class="mydialog" :title="dialogTitle" v-model="dialogVisible" width="50vw"
			:close-on-click-modal="false" :close-on-press-escape="false" destroy-on-close align-center>
			<el-form :model="processForm" :rules="rules" ref="processForm" label-width="auto" v-loading="dialogLoading">
				<el-form-item label="流程名称" prop="name">
					<el-input v-model="processForm.name" placeholder="请输入流程名称" />
				</el-form-item>
				<el-form-item label="流程描述" prop="description">
					<el-input v-model="processForm.description" type="textarea" :rows="3" placeholder="请输入流程描述" />
				</el-form-item>

				<!-- 审批步骤配置 -->
				<el-form-item label="审批步骤" prop="tbTemUsers">
					<div class="approval-tbTemUsers">
						<div v-for="(step, index) in processForm.tbTemUsers" :key="index" class="step-item">
							<div class="step-header">
								<span class="step-number">第{{ index + 1 }}步</span>
								<el-button type="danger" size="mini" @click="removeStep(index)"
									v-if="processForm.tbTemUsers.length > 1">
									删除
								</el-button>
							</div>
							<div class="step-content">
								<el-row :gutter="10">
									<el-col :span="8">
										<el-form-item :prop="`tbTemUsers.${index}.userId`" :rules="stepRules.userId">
											<el-select v-model="step.userId" placeholder="选择审批人" filterable remote
												:remote-method="(query) => handleUserSearch(query)"
												:loading="userSearchLoading" @change="handleUserChange($event, index)">
												<el-option v-for="user in userOptions" :key="user.id"
													:label="user.username" :value="user.id">
													<span>{{ user.username }}</span>
													<!-- <span class="user-dept">{{ user.departmentName }}</span> -->
												</el-option>
											</el-select>
										</el-form-item>
									</el-col>
									<!-- <el-col :span="8">
                    <el-form-item :prop="`tbTemUsers.${index}.type`" :rules="stepRules.type">
                      <el-select v-model="step.type" placeholder="审批类型">
                        <el-option label="依次审批" value="sequential" />
                        <el-option label="或签审批" value="or" />
                        <el-option label="会签审批" value="and" />
                      </el-select>
                    </el-form-item>
                  </el-col> -->
									<el-col :span="8">
										<el-form-item :prop="`tbTemUsers.${index}.sort`">
											<el-input v-model="step.sort" placeholder="排序" disabled
												:value="index + 1" />
										</el-form-item>
									</el-col>
								</el-row>
							</div>
						</div>
						<el-button type="dashed" @click="addStep" class="add-step-btn">
							<el-icon>
								<Plus />
							</el-icon> 添加审批步骤
						</el-button>
					</div>
				</el-form-item>
				<el-form-item label="抄送人" prop="ccUsers" :rules="stepRules.ccUsers">
					<el-select v-model="processForm.ccUsers" multiple filterable remote
						:remote-method="(query) => handleUserSearch(query)" :loading="userSearchLoading"
						placeholder="请输入用户名搜索" style="width: 100%">
						<el-option v-for="item in userOptions" :key="item.id" :label="item.username" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="dialogVisible = false">取消</el-button>
					<el-button type="primary" @click="submitForm" :loading="submitLoading">
						确定
					</el-button>
				</span>
			</template>
		</el-dialog>

		<!-- 查看流程对话框 -->
		<el-dialog class="mydialog" title="查看审批流程" v-model="viewDialogVisible" width="50vw"
			:close-on-click-modal="false" align-center>
			<el-tabs v-model="activeTab" type="border-card">
				<el-tab-pane label="基本信息" name="basic">
					<div class="contacts-section">
						<el-descriptions :column="1" border>
							<el-descriptions-item label="流程名称">{{ viewProcess.name }}</el-descriptions-item>
							<el-descriptions-item label="流程描述">{{ viewProcess.description }}</el-descriptions-item>
							<el-descriptions-item
								label="创建时间">{{ formatDate(viewProcess.createTime) }}</el-descriptions-item>
						</el-descriptions>
					</div>
				</el-tab-pane>

				<el-tab-pane label="审批流程" name="steps">
					<div class="contacts-section">
						<el-timeline>
							<el-timeline-item v-for="(step, index) in viewProcess.tbTemUsers" :key="index"
								:color="getTimelineColor(index)" :type="index === 0 ? 'primary' : 'default'">
								<div class="timeline-item-content">
									<h4>第{{ index + 1 }}步</h4>
									<p><strong>审批人：</strong>{{ step.username }}</p>
									<p><strong>审批类型：</strong>依次审批</p>
									<p v-if="step.status !== undefined"><strong>审批状态：</strong>
										<el-tag :type="getApprovalStatusType(step.status)" size="small">
											{{ getApprovalStatusText(step.status) }}
										</el-tag>
									</p>
									<p v-if="step.remark"><strong>审批意见：</strong>{{ step.remark }}</p>
									<p v-if="step.approveTime"><strong>审批时间：</strong>{{ formatDate(step.approveTime) }}
									</p>
								</div>
							</el-timeline-item>
						</el-timeline>
					</div>
				</el-tab-pane>

				<!-- <el-tab-pane label="报价信息" name="quotation">
          <div v-if="viewProcess.quotationInfo">
            <el-descriptions :column="2" border>
              <el-descriptions-item label="报价编号">{{ viewProcess.quotationInfo.name }}</el-descriptions-item>
              <el-descriptions-item label="客户名称">{{ viewProcess.quotationInfo.customerName }}</el-descriptions-item>
              <el-descriptions-item label="报价金额">{{ formatAmount(viewProcess.quotationInfo.offerPrice) }}</el-descriptions-item>
              <el-descriptions-item label="成本金额">{{ formatAmount(viewProcess.quotationInfo.cost) }}</el-descriptions-item>
              <el-descriptions-item label="利润金额">{{ formatAmount(viewProcess.quotationInfo.profit) }}</el-descriptions-item>
              <el-descriptions-item label="有效期至">{{ formatDate(viewProcess.quotationInfo.offerTime) }}</el-descriptions-item>
              <el-descriptions-item label="报价状态">
                <el-tag :type="getQuotationStatusType(viewProcess.quotationInfo.status)">
                  {{ getQuotationStatusText(viewProcess.quotationInfo.status) }}
                </el-tag>
              </el-descriptions-item>
              <el-descriptions-item label="创建时间">{{ formatDate(viewProcess.quotationInfo.createTime) }}</el-descriptions-item>
              <el-descriptions-item label="备注说明" :span="2">{{ viewProcess.quotationInfo.remark || '无' }}</el-descriptions-item>
            </el-descriptions>

            <h3 style="margin-top: 20px;">报价明细</h3>
            <el-table :data="viewProcess.quotationInfo.businessProducts" border style="width: 100%">
              <el-table-column type="index" label="序号" width="60" />
              <el-table-column prop="productName" label="产品名称"></el-table-column>
              <el-table-column prop="unit" label="单位" width="80"></el-table-column>
              <el-table-column prop="productNum" label="数量" width="100"></el-table-column>
              <el-table-column prop="productPrice" label="单价" width="120">
                <template #default="scope">
                  {{ formatAmount(scope.row.productPrice) }}
                </template>
              </el-table-column>
              <el-table-column prop="amount" label="金额" width="120">
                <template #default="scope">
                  {{ formatAmount(scope.row.amount) }}
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-empty v-else description="暂无报价信息"></el-empty>
        </el-tab-pane> -->
			</el-tabs>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getExamineTem,
		addApprovalProcess,
		updateApprovalProcess,
		toggleApprovalProcessStatus,
		getUserList
	} from '@/api/approval'
	import {
		Plus,
		Search,
		Refresh
	} from '@element-plus/icons-vue'
	import {
		ElMessage,
		ElMessageBox
	} from 'element-plus'

	export default {
		name: 'ApprovalProcessManagement',
		components: {
			Plus,
			Search,
			Refresh
		},
		data() {
			return {
				loading: false,
				dialogLoading: false,
				submitLoading: false,
				userSearchLoading: false,
				filterForm: {
					name: '',
					status: ''
				},
				processList: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				dialogVisible: false,
				viewDialogVisible: false,
				dialogTitle: '新建审批流程',
				viewProcess: {},
				processForm: {
					name: '',
					description: '',
					tbTemUsers: [{
						userId: '',
						userName: '',
						departmentName: '',
						type: 'sequential',
						condition: '',
					}],
					ccUsers: [],
					status: 'active'
				},
				rules: {
					name: [{
						required: true,
						message: '请输入流程名称',
						trigger: 'blur'
					}],
					description: [{
						required: true,
						message: '请输入流程描述',
						trigger: 'blur'
					}],
					tbTemUsers: [{
						required: true,
						message: '请配置至少一个审批步骤',
						trigger: 'change'
					}]
				},
				stepRules: {
					userId: [{
						required: true,
						message: '请选择审批人',
						trigger: 'change'
					}],
					type: [{
						required: true,
						message: '请选择审批类型',
						trigger: 'change'
					}],
					ccUsers: [{
						required: true,
						message: '请选择抄送人',
						trigger: 'change'
					}]
				},
				userOptions: [],
				activeTab: 'basic'
			}
		},
		created() {
			this.fetchData()
		},
		methods: {
			async fetchData() {
				this.loading = true
				try {
					const data = {
						current: this.currentPage,
						size: this.pageSize,
						...this.filterForm
					}
					const res = await getExamineTem(data)
					this.processList = res.data.records
					this.total = res.data.total
				} catch (error) {
					console.error('获取审批流程列表失败:', error)
					ElMessage.error('获取审批流程列表失败')
				} finally {
					this.loading = false
				}
			},

			handleSearch() {
				this.currentPage = 1
				this.fetchData()
			},

			resetForm() {
				this.filterForm = {
					name: '',
					status: ''
				}
				this.handleSearch()
			},

			handleSizeChange(val) {
				this.pageSize = val
				this.fetchData()
			},

			handleCurrentChange(val) {
				this.currentPage = val
				this.fetchData()
			},

			handleAdd() {
				this.dialogTitle = '新建审批流程'
				this.processForm = {
					name: '',
					description: '',
					tbTemUsers: [{
						userId: '',
						sort: 1,
						type: 'sequential',
						condition: ''
					}],
					status: 'active'
				}
				this.dialogVisible = true
			},

			handleView(row) {
				this.viewProcess = {
					...row
				}
				this.viewDialogVisible = true
			},

			handleEdit(row) {
				this.dialogTitle = '编辑审批流程'

				row.tbTemUsers.forEach(item => {
					// item.userId = item.userId.toString()
					this.userOptions.push({
						id: item.userId,
						username: item.username,
						// departmentName: item.departmentName
					})
				})
				this.processForm = {
					...row
				}
				console.log(this.processForm);
				console.log(this.userOptions);
				this.dialogVisible = true
			},

			async handleToggleStatus(row) {
				try {
					await ElMessageBox.confirm(
						`确认${row.status === 'active' ? '停用' : '启用'}该审批流程吗？`,
						'提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}
					)
					const newStatus = row.status === 'active' ? 'inactive' : 'active'
					await toggleApprovalProcessStatus(row.id, newStatus)
					ElMessage.success(`${newStatus === 'active' ? '启用' : '停用'}成功`)
					this.fetchData()
				} catch (error) {
					if (error !== 'cancel') {
						console.error('切换流程状态失败:', error)
						ElMessage.error('操作失败')
					}
				}
			},

			addStep() {
				this.processForm.tbTemUsers.push({
					userId: '',
					userName: '',
					departmentName: '',
					type: 'sequential',
					sort: '',
					condition: ''
				})
			},

			removeStep(index) {
				this.processForm.tbTemUsers.splice(index, 1)
			},

			async handleUserSearch(query) {
				console.log(query);
				if (query) {
					this.userSearchLoading = true
					try {
						const res = await getUserList({
							name: query
						})
						this.userOptions = res.data
					} catch (error) {
						console.error('搜索用户失败:', error)
					} finally {
						this.userSearchLoading = false
					}
				} else {
					this.userOptions = []
				}
			},

			handleUserChange(userId, index) {
				const user = this.userOptions.find(u => u.id === userId)
				if (user) {
					this.processForm.tbTemUsers[index].userName = user.name
					this.processForm.tbTemUsers[index].departmentName = user.departmentName
				}
			},

			async submitForm() {
				try {
					await this.$refs.processForm.validate()
					this.submitLoading = true

					// 验证所有步骤都已配置
					const hasEmptyStep = this.processForm.tbTemUsers.some(step => !step.userId)
					if (hasEmptyStep) {
						ElMessage.error('请完善所有审批步骤的配置')
						return
					}

					if (this.processForm.id) {
						await updateApprovalProcess(this.processForm)
						ElMessage.success('更新成功')
					} else {
						await addApprovalProcess(this.processForm)
						ElMessage.success('创建成功')
					}
					this.dialogVisible = false
					this.fetchData()
				} catch (error) {
					if (error.message) {
						ElMessage.error(error.message)
					}
					console.error('提交表单失败:', error)
				} finally {
					this.submitLoading = false
				}
			},

			getStepTag(index) {
				const colors = ['primary', 'success', 'warning', 'danger', 'info']
				return colors[index % colors.length]
			},

			getTimelineColor(index) {
				const colors = ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#909399']
				return colors[index % colors.length]
			},

			getApprovalTypeText(type) {
				const typeMap = {
					sequential: '依次审批',
					or: '或签审批',
					and: '会签审批'
				}
				return typeMap[type] || type
			},

			formatDate(date) {
				if (!date) return ''
				const d = new Date(date)
				const year = d.getFullYear()
				const month = String(d.getMonth() + 1).padStart(2, '0')
				const day = String(d.getDate()).padStart(2, '0')
				const hour = String(d.getHours()).padStart(2, '0')
				const minute = String(d.getMinutes()).padStart(2, '0')
				const second = String(d.getSeconds()).padStart(2, '0')
				return `${year}-${month}-${day} ${hour}:${minute}:${second}`
			},

			formatAmount(amount) {
				if (!amount && amount !== 0) return '¥0.00'
				return `¥${Number(amount).toFixed(2)}`
			},

			getQuotationStatusType(status) {
				const statusMap = {
					0: 'primary',
					1: 'success',
					2: 'danger'
				}
				return statusMap[status] || 'info'
			},

			getQuotationStatusText(status) {
				const statusMap = {
					0: '审核中',
					1: '已审核',
					2: '已拒绝'
				}
				return statusMap[status] || status
			},

			getApprovalStatusType(status) {
				const statusMap = {
					0: 'warning', // 待审批
					1: 'success', // 已通过
					2: 'danger', // 已拒绝
					3: 'info' // 已撤回
				}
				return statusMap[status] || 'info'
			},

			getApprovalStatusText(status) {
				const statusMap = {
					0: '待审批',
					1: '已通过',
					2: '已拒绝',
					3: '已撤回'
				}
				return statusMap[status] || '未知'
			}
		}
	}
</script>

<style scoped>
	.approval-process-management {
		/* padding: 20px; */
	}

	.page-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
	}

	.header-actions {
		display: flex;
		gap: 10px;
	}

	.filter-form {
		display: flex;
		flex-wrap: wrap;
		gap: 10px;
	}

	.pagination-container {
		margin-top: 20px;
		text-align: right;
	}

	.approver-list {
		display: flex;
		flex-wrap: wrap;
		gap: 5px;
	}

	.step-tag {
		margin-bottom: 5px;
	}

	.approval-tbTemUsers {
		border: 1px solid #e4e7ed;
		border-radius: 4px;
		padding: 15px;
	}

	.step-item {
		margin-bottom: 15px;
		border: 1px solid #f0f0f0;
		border-radius: 4px;
		padding: 10px;
	}

	.step-item:last-child {
		margin-bottom: 0;
	}

	.step-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
	}

	.step-number {
		font-weight: bold;
		color: #409EFF;
	}

	.step-content {
		background-color: #fafafa;
		padding: 10px;
		border-radius: 4px;
	}

	.add-step-btn {
		width: 100%;
		margin-top: 10px;
		border: 1px dashed #d9d9d9;
		background-color: #fafafa;
	}

	.add-step-btn:hover {
		border-color: #409EFF;
		color: #409EFF;
	}

	.user-dept {
		float: right;
		color: #8492a6;
		font-size: 12px;
	}

	.timeline-item-content h4 {
		margin: 0 0 10px 0;
		color: #409EFF;
	}

	.timeline-item-content p {
		margin: 5px 0;
		color: #606266;
	}

	/* 响应式布局 */
	@media screen and (max-width: 768px) {
		.filter-form {
			flex-direction: column;
		}

		.filter-form .el-form-item {
			margin-right: 0;
			width: 100%;
		}

		.header-actions {
			flex-direction: column;
		}

		.step-content .el-col {
			width: 100%;
			margin-bottom: 10px;
		}
	}
</style>